export default __webpack_public_path__ + "static/media/defaultPic.e584798b.svg";